import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const PhotoIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 12, height = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_1996_26936)">
          <path
            d="M7.5 4H7.505M1.5 8L4 5.5C4.464 5.0535 5.036 5.0535 5.5 5.5L8 8M7 7L7.5 6.5C7.964 6.0535 8.536 6.0535 9 6.5L10.5 8M1.5 3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H9C9.39782 1.5 9.77936 1.65804 10.0607 1.93934C10.342 2.22064 10.5 2.60218 10.5 3V9C10.5 9.39782 10.342 9.77936 10.0607 10.0607C9.77936 10.342 9.39782 10.5 9 10.5H3C2.60218 10.5 2.22064 10.342 1.93934 10.0607C1.65804 9.77936 1.5 9.39782 1.5 9V3Z"
            stroke="#1677FF"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1996_26936">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
